
    function AppJS() {

        var $body = jQuery('body');
        var $window = $(window);

        window.app.state = {
            debug: false,
            region: (!$body.hasClass('nz') ? 'au' : 'nz'),
            isStaging: getStaging(),
            siteUrl: getSiteUrl(),
            urlParams: getUrlParams(),
            hires: getHires(),
            isIOS: getIOS(),
            isIPad: getIpad(),
            isIPhone: getIphone(),
            isAndroid: getAndroid(),
            hasTouch: getHasTouch(),
            breakpoint: null,
            winWidth: null,
            winHeight: null,
        };

        if (window.app.state.isStaging) {
            window.app.state.debug = true;
        }

        if (!window.app.state.debug) {
        } else {
            $body.addClass('debug');
        }

        // FastClick.attach(document.body);

        var throttledResize = _.throttle(onResize, 150);
        $(window).on('resize orientationchange', throttledResize);
        onResize();


        //
        //
        //  following functions populate app.state {}
        //
        //

        function onResize(e) {
            window.app.state.winWidth = $window.width();
            window.app.state.winHeight = $window.height();
            var active = im.getActive();
            window.app.state.breakpoint = active;

            // https://css-tricks.com/the-trick-to-viewport-units-on-mobile/
            var vh = window.innerHeight * 0.01;
            document.documentElement.style.setProperty('--vh', vh + 'px');
        }

        function getSiteUrl() {
            
            var loc = window.location;

            /*
            // live test
            loc = document.createElement('a');
            loc.href = 'https://www.penguin.com.au';
            */
            
            var href = loc.href;
            var origin = loc.origin;
            var hostname = loc.hostname;
            var host = loc.host;
            var pathname = loc.pathname;
            var port = loc.port;
            var protocol = loc.protocol;

            var isStaging = href.indexOf('staging.chookdigital') !== -1;
            var isLocalhost = href.indexOf('localhost') !== -1;
            var isExternal = href.indexOf('192.168') !== -1;
            
            /*
            */
            
            // removes protocol
            // removes params
            var h = href
                .replace(protocol + '//', '')
                .split('?')[0];
            const hSplit = h.split('/');

            if (isLocalhost || isExternal) {
                
                /*
                // 192.168.18.207:3000/test/
                domain = hSplit[0];
                // -> 192.168.18.207:3000
                return '//' + domain + '/';
                // -> //192.168.18.207:3000
                */
                
                // localhost:3000/penguin.com.au/test/
                var domain = hSplit[1];
                // -> penguin.com.au
                var host = hSplit[0];
                // -> localhost:3000

                if (domain === "") {
                    // -> localhost:3000
                    return '//' + host + '/';
                } else {
                    // -> //localhost:3000/penguin.com.au/
                    return '//' + host + '/' + domain + '/';
                }
            }

            if (isStaging) {
                // staging.chookdigital.net/penguin.com.au/test/
                return '//' + hSplit[0] + '/' + hSplit[1] + '/';
            }

            // live
            return '//' + host + '/';
        }

        function getStaging() {
            var href = window.location.href;
            return (href.indexOf('staging.chookdigital') !== -1 || href.indexOf('localhost') !== -1 || href.indexOf('192.168') !== -1)
        }

        function getIOS() {
            var isIOS =  /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
            if (isIOS) {
                $body.addClass('ios');
                return true;
            } else {
                return false;
            }
        }

        function getIpad() {
            var isIpad = /iPad/.test(navigator.userAgent) && !window.MSStream;
            if (isIpad) {
                $body.addClass('ipad');
                return true;
            } else {
                return false;
            }
        }

        function getIphone() {
            var isIphone = /iPhone/.test(navigator.userAgent) && !window.MSStream;
            if (isIphone) {
                $body.addClass('iphone');
                return true;
            } else {
                return false;
            }
        }

        function getAndroid() {
            var isAndroid = /Android/i.test(navigator.userAgent);
            if (isAndroid) {
                $body.addClass('android');
                return true;
            } else {
                return false;
            }
        }

        function getHires() {
            // hires
            var dpr = window.devicePixelRatio ||
                // fallback for IE
                (window.screen.deviceXDPI / window.screen.logicalXDPI) ||
                // default value
                1;
            if (!!(dpr > 1)) {
                $body.addClass('hires');
                return true;
            } else {
                return false;
            };
        }

        function getHasTouch() {
            var hasTouch = ('ontouchstart' in window || typeof window.navigator.msPointerEnabled !== 'undefined');
            if (hasTouch) {
                $body.addClass('has-touch');
            } else {
                $body.addClass('no-touch');
            }
            return hasTouch;
        }

        function getUrlParams(url) {
            var params = {}
            var match,
                    pl = /\+/g,  // Regex for replacing addition symbol with a space
                    search = /([^&=]+)=?([^&]*)/g,
                    decode = function (s) { return decodeURIComponent(s.replace(pl, " ")); },
                    query = (typeof url !== 'undefined') ? url: window.location.search.substring(1);

            while (match = search.exec(query))
                params[decode(match[1])] = decode(match[2]);

            return params;
        }
        // expose
        window.app.getUrlParams = getUrlParams;


        // Track execution to prevent multiple runs
        var heightEqualizationTimeout = null;
        var heightEqualizationExecuted = false;
        
        window.app.equalizeBookBlockHeights = function() {
            
            // Clear any pending timeout
            if (heightEqualizationTimeout) {
                clearTimeout(heightEqualizationTimeout);
            }
            
            // Skip if already executed
            if (heightEqualizationExecuted) {
                return;
            }
            
            // Set timeout to ensure it only runs once after all events settle
            heightEqualizationTimeout = setTimeout(function() {
                
                // Double-check we haven't executed yet
                if (heightEqualizationExecuted) {
                    return;
                }
                
                var $bookBlocks = $('.c-book-block, .c-book-block-hero');
                
                $bookBlocks.each(function() {
                    var $block = $(this);
                    var $thumbContainers, $thumbLinks;
                    
                    if ($block.hasClass('c-book-block-hero')) {
                        $thumbContainers = $block.find('.c-book-block-hero__thumb');
                        $thumbLinks = $block.find('.c-book-block-hero__thumb a');
                    } else {
                        $thumbContainers = $block.find('.c-book-block__thumb');
                        $thumbLinks = $block.find('.c-book-block__thumb a');
                    }
                    
                    
                    var maxHeight = 0;
                    
                    $thumbContainers.css('transition', 'none');
                    $thumbContainers.css('min-height', '');
                    
                    $thumbContainers[0] && $thumbContainers[0].offsetHeight;
                    
                    $thumbLinks.each(function() {
                        var height = $(this).outerHeight();
                        if (height > maxHeight) {
                            maxHeight = height;
                        }
                    });
                    
                    
                    if (maxHeight > 0) {
                        $thumbContainers.css('transition', 'min-height 0.15s ease-in-out');
                        $thumbContainers.css('min-height', maxHeight + 'px');
                    }
                });
                
                heightEqualizationExecuted = true;
            }, 100);
        };
        
        $(document).ready(function() {
            setTimeout(function() {
                window.app.equalizeBookBlockHeights();
            }, 500);
        });
        
        // Also run when page becomes visible (handles navigation scenarios)
        $(document).on('visibilitychange', function() {
            if (!document.hidden) {
                setTimeout(function() {
                    window.app.equalizeBookBlockHeights();
                }, 500);
            }
        });
        
        // Also run on page show event (for back/forward navigation)
        $(window).on('pageshow', function() {
            setTimeout(function() {
                window.app.equalizeBookBlockHeights();
            }, 500);
        });
        
        // Reset execution flag when navigating away from page
        $(window).on('beforeunload pagehide', function() {
            heightEqualizationExecuted = false;
            if (heightEqualizationTimeout) {
                clearTimeout(heightEqualizationTimeout);
                heightEqualizationTimeout = null;
            }
        });
        
        // Also reset on page load to ensure fresh start
        $(document).ready(function() {
            heightEqualizationExecuted = false;
        });


    }

export default AppJS;